<script lang="ts" setup>
import PopupActionType from "@/enums/PopupActionType";
import { ref, watch } from "vue";

interface IPopupProps {
    title?: string;
    subTitle?: string;
    body?: string;
    cancelLabel?: string;
    okLabel?: string ;
    modalOpen?: boolean;
    persistent?: boolean;
    showOk?: boolean;
    showCancel?: boolean;
    okDisabled?: boolean;
    width?: number | null;
}

const props = defineProps<IPopupProps>();

const isOpen = ref(false);
const emit = defineEmits(["onDialogResult"]);

watch(
    () => props.modalOpen,
    async () => {
        isOpen.value = props.modalOpen;
    }
);

function onClickCancelButton() {
    isOpen.value = false;
    emit("onDialogResult", PopupActionType.Cancel);
}

function onClickConfirmButton() {
    if (props.okDisabled) {
        return;
    }
    isOpen.value = false;
    emit("onDialogResult", PopupActionType.Confirm);
}

function onClickOutSide() {
    if (props.modalOpen) {
        isOpen.value = false;
        emit("onDialogResult", PopupActionType.Outside);
    }
}
</script>

<template>
    <v-dialog v-model="isOpen" scrollable :persistent="props.persistent" :min-width="props.width ?? 500" :max-width="props.width ?? 500" @click:outside="onClickOutSide">>
        <v-card class="mx-auto rounded-lg" v-if="isOpen" width="100%">
            <v-card-title>
                <header class="app-welcome-message">
                    <v-row>
                        <v-col cols="10">
                            <h2 class="pb-0 mb-0">{{ props.title }}</h2>
                            <h4 class="text-subtitle-2 blue-grey-darken">{{ props.subTitle }}</h4>
                        </v-col>
                        <v-col cols="2">
                            <v-btn icon variant="text" size="x-small" class="float-right blue-grey-darken"
                                v-on:click="onClickCancelButton">
                                <v-icon size="18">mdi-close</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </header>
            </v-card-title>
            <v-card-text class="pa-4">

                <slot name="body" class="pa-0">
                    <div>{{ props.body }}</div>
                </slot>

            </v-card-text>
            <v-card-actions class="pa-4">
                <slot name="footer" class="pa-0">
                    <v-spacer />
                    <v-btn v-if="props.showCancel" v-on:click="onClickCancelButton"> {{ props.cancelLabel ?? "Annuleren" }} </v-btn>
                    <v-btn v-if="props.showOk" color="primary" variant="tonal" :disabled="props.okDisabled" v-on:click="onClickConfirmButton"> {{ props.okLabel ?? "Ok" }} </v-btn>
                </slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped lang="scss">
.blue-grey-darken {
    color: var(--blue-grey-darken-1);
}
</style>